import { Component, AfterViewInit } from "@angular/core";
import { JiraService } from "../../services/jira/jira.service";
import { SyncProgressService } from "../../services/sync-progress/sync-progress.service";
import { environment } from "../../../environments/environment";
import { MzBaseModal } from "ng2-materialize";
import { Observable } from "rxjs/Rx";
import { UUID } from "angular2-uuid";

@Component({
  selector: "app-jira-sync-progress",
  templateUrl: "./jira-sync-progress.component.html",
  styleUrls: ["./jira-sync-progress.component.scss"],
})
export class JiraSyncProgressComponent
  extends MzBaseModal
  implements AfterViewInit {
  env: any = environment;
  progressId: string = UUID.UUID();
  progress: Observable<number> = this.syncProgressService
    .watch(this.progressId)
    .startWith(0);

  constructor(
    private jiraService: JiraService,
    private syncProgressService: SyncProgressService
  ) {
    super();
  }

  ngAfterViewInit() {}

  public async sync(projectShortId: string) {
    this.modalComponent.open();
    await this.jiraService.syncProject(projectShortId, this.progressId);
    this.modalComponent.close();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/jira-sync-progress/jira-sync-progress.component.ts